import * as React from 'react';

import { ElementRect, useElementRect } from '@rematter/ui-web/hooks';

export type HeaderRect = {
  width: number;
  height: number;
  left: number;
  top: number;
  bottom: number;
  right: number;
};

export const EMPTY_HEADER_RECT: HeaderRect = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  bottom: 0,
  right: 0,
};

const MODAL_SPACING = 10;

export const FALLBACK_MODAL_STYLE: React.CSSProperties = {
  position: 'fixed',
  left: MODAL_SPACING,
  top: MODAL_SPACING,
  height: `calc(100vh - ${MODAL_SPACING}px)`,
  width: `calc(100vw - ${MODAL_SPACING * 2}px)`,
};

export const calculateModalStyle = (headerRect: {
  width: number;
  height: number;
  left: number;
  top: number;
}): React.CSSProperties => ({
  position: 'fixed',
  left: headerRect.left,
  width: headerRect.width,
  top: headerRect.top,
  height: headerRect.height,
});

export function useHeaderRectMeasurement(
  onRectChange: (rect: HeaderRect) => void,
) {
  const handleChange = React.useCallback(
    (rect: ElementRect) => {
      onRectChange(rect);
    },
    [onRectChange],
  );

  return useElementRect<HTMLDivElement>(handleChange);
}
